import { Component, OnInit, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder } from '@angular/forms';
import { VisaDesignerService } from '../visa-designer.service';
//import { FroalaEditorOptions } from '../../../data/constants/froala-editor-options';
//import * as  froalaService from 'src/app/modules/utility/froala-service';
import { ClipboardService } from 'ngx-clipboard';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
//import { VisaDesignerService } from '../../../services/visa-designer.service';
import { UploadImageDialogComponent } from "../../custom-kendo/upload-image-dialog/upload-image-dialog.component";
import { EditorComponent } from "@progress/kendo-angular-editor";

@Component({
  selector: 'app-vd-default-template',
  templateUrl: './vd-default-template.component.html',
  styleUrls: ['./vd-default-template.component.scss']
})
export class VdDefaultTemplateComponent implements OnInit {

  @ViewChild("vddefaulttemplateHeaderupload") public vddefaulttemplateHeaderupload: UploadImageDialogComponent;
  @ViewChild("vddefaulttemplateContentupload") public vddefaulttemplateContentupload: UploadImageDialogComponent;
  @ViewChild("vddefaulttemplateFooterupload") public vddefaulttemplateFooterupload: UploadImageDialogComponent;
  
@Output() @ViewChild("vddefaulttemplateHeaderkendoeditor") public vddefaulttemplateHeaderkendoeditor: EditorComponent;
@Output() @ViewChild("vddefaulttemplateContentkendoeditor") public vddefaulttemplateContentkendoeditor: EditorComponent;
@Output() @ViewChild("vddefaulttemplateFooterkendoeditor") public vddefaulttemplateFooterkendoeditor: EditorComponent;

  // public options = FroalaEditorOptions.EditorOptions;
  copiedIndex: any;
  // addForm: FormGroup;
  user: Boolean = false;
  visaInfo: any;
  placeHolderList = [];
  header: any;
  footer: any;
  body: any;
  observableSubscription$ = new Subject();
  letterType: any;
  visaId: string;
  isEditVisa: boolean = false;
  constructor(private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService, private fb: FormBuilder, private vdService: VisaDesignerService, private clipboardService: ClipboardService,) {
  }

  ngOnInit() {
    this.route.queryParams
      .pipe(takeUntil(this.observableSubscription$)).
      subscribe((params) => {
        this.letterType = params['type'] || null;
        console.log(params, this.letterType);
        if (this.letterType) {
          // this.getDefaultLetterTemplate(this.letterType)
        }
      });

    this.visaId = localStorage.getItem('visaId');
    this.vdService.getVisaById(this.visaId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.visaInfo = response.data;
      this.placeHolderList = response.data && response.data.tmpltPlcHldrJson ? JSON.parse(response.data.tmpltPlcHldrJson) : [];
      this.getDefaultLetterTemplate(this.letterType);
    });

    // this.vdService.getVisaInfo.subscribe((response) => {
    //   console.log("template summary view response",response);
    //   this.visaInfo = response;
    //   this.placeHolderList = response.tmpltPlcHldrJson ?  JSON.parse(response.tmpltPlcHldrJson):[];
    //   this.getDefaultLetterTemplate(this.letterType)
    //   console.log("filter changed", this.placeHolderList);
    // });
    this.isEditVisa = localStorage.getItem('isEditVisa') === 'true' ? true : false;
  }

  
  getDefaultLetterTemplate(letterType) {
    this.vdService.getDefaultLetterTemplate(this.visaInfo.visaId, letterType).subscribe((response) => {
      console.log("default template", response);
      if (response) {
        this.header = response.data && response.data.header ? response.data.header : null;
        this.footer = response.data && response.data.footer ? response.data.footer : null;
        this.body = response.data && response.data.body ? response.data.body : null;
      }
    });
  }

  handleGoback() {
    this.router.navigate([`../../generate-letters`], { relativeTo: this.route });
  }

  copied(e, item, index) {
    this.toastr.info(`${item.description} copied`);
    this.copiedIndex = index;
  }
  handleCopy(item) {
    this.toastr.info(`${item.description} copied`);
    this.clipboardService.copyFromContent(item.placeHolderName);
  }
  handleSave() {
    const payload = {

      header: this.header,
      footer: this.footer,
      body: this.body


    }
    this.vdService.saveDefaultLetterTemplate(this.visaInfo.visaId, this.letterType, payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      console.log("create task", response);
      if (response && response.status === 200) {
        this.toastr.success(response.message, 'Success');
        // this.resetForm();
        if (response.data) {
          // this.router.navigate([`../../visa-details-steps/${response.data}`], { relativeTo: this.route });
        }

      }
    });
  }

  vddefaulttemplateHeadereditorValueChange(value: string): void {
    this.header = value;
  }

  vddefaulttemplateContenteditorValueChange(value: string): void {
    this.body = value;
  }

  vddefaulttemplateFootereditorValueChange(value: string): void {
    this.footer = value;
  }

  openvddefaulttemplateHeaderimageuploaddialog() {    
    this.vddefaulttemplateHeaderupload.open();
  }
  openvddefaulttemplateContentimageuploaddialog() {    
    this.vddefaulttemplateContentupload.open();
  }
  openvddefaulttemplateFooterimageuploaddialog() {    
    this.vddefaulttemplateFooterupload.open();
  }
}















